export default {
  depositionsHome: {
    title: ['Quem é', 'a SIS'],
    subtitle: 'O que nossos colaboradores andam dizendo?',
  },
}
